<template>
    <component :is="template">
        <div>
            <div id="print">
                <div class="print-area">
                    <div class="print-area__inner">
                        <div class="tit-wrap tit-wrap--unberline">
                            <h2 class="tit">도서 구매내역</h2>
                        </div>

                        <section class="page-section pt-0">
                            <v-data-table :items="purchases" :headers="purchasesHeaders.filter((header) => (header.display ? header.display(code) : true))" disable-pagination disable-sort hide-default-footer mobile-breakpoint="768" width="100%">
                                <template slot="item.product" slot-scope="{item}">
                                    <div class="img-wrap d-inline-block border cursor-pointer">
                                        <router-link :to="`/shop/products/${item.product._mainProduct || item.product._id}`">
                                            <v-img :src="item?.product?.thumb" width="100" :aspect-ratio="1/1" contain/>
                                        </router-link>
                                    </div>
                                </template>
                                <div slot="item.actions" slot-scope="{item}">
                                    <v-btn v-if="(item.status == '주문완료' || item.status == '상품준비중' || item.status == '발송지연')" x-small outlined color="primary" :disabled="item.isClaim || item.giftStatus == '선물받기완료' || item.giftStatus == '선물포인트전환완료'" @click="claim(item, `cancel`)" style="font-weight:bold">취소요청</v-btn>
                                    <v-btn v-if="(item.status != '주문완료' && item.status != '상품준비중' && item.status != '발송지연' && item.purchaseStatus != '구매확정완료' && item.status != '취소완료' && item.status) && !item.isClaim && item.ebookStatus != '열람'" x-small outlined color="primary" :disabled="item.isClaim" @click="claim(item, `return`)" style="font-weight:bold">반품요청</v-btn>
                                    <!-- <v-btn v-if="!item.isClaim" x-small outlined color="primary" :disabled="item.isClaim" @click="claim(item, `exchange`)">교환요청</v-btn> -->
                                    <v-btn v-if="(item.status == '배송완료' && !item.isClaim && !item.review && item.purchaseStatus == '구매확정완료') || (item.status == '반품반려' && item.isClaim && !item.review )" x-small outlined color="primary"  @click="review(item)" style="font-weight:bold">상품리뷰</v-btn>
                                    <v-btn v-if="item.status == '배송완료' && !item.isClaim && !item.review && item.purchaseStatus != '구매확정완료'" x-small outlined color="primary" :disabled="item.isClaim" @click="confirmation(item)" style="font-weight:bold">구매확정</v-btn>
                                </div>
                                <template slot="item.name" slot-scope="{item}">
                                    <div class="cursor-pointer">
                                        <router-link :to="`/shop/products/${item.product._mainProduct || item.product._id}`">
                                            <div>{{ item?.product?.name}}</div>
                                        </router-link>
                                    </div>
                                </template>
                                <v-responsive slot="item.saleAmount" slot-scope="{item}">
                                    <v-flex>
                                        <div class="mx-2 text-truncate">{{ item.saleAmount.format() }}원</div>
                                    </v-flex>
                                </v-responsive>
                                <v-responsive slot="item.earnPointAmount" slot-scope="{item}">
                                    <v-flex>
                                        <div class="mx-2 text-truncate">{{ item.earnPointAmount.format() }}원</div>
                                    </v-flex>
                                </v-responsive>
                                <div slot="item.shippingInfo" slot-scope="{item}">
                                    <div>{{ item.shippingInfo.method }}</div>
                                    <div>{{ item.shippingInfo.invoiceNumber }}</div>
                                    <div>{{ couriers.find(courier => courier.code == item.shippingInfo.courier)?.text }}</div>
                                </div>
                            </v-data-table>

                            <div class="my-4">
                                <div class="card--primary">
                                    <v-row align="center" justify="center" class="row--x-small font-size-14 font-size-md-16">
                                        <v-col cols="auto">
                                            <span>상품(<b>{{ order?.saleAmount.format() }}원</b>)</span>
                                        </v-col>
                                        <v-col cols="auto">+</v-col>
                                        <v-col cols="auto">
                                            <span>배송비(<b>{{ order?.shippingAmount.format() }}원</b>)</span>
                                        </v-col>
                                        <v-col cols="auto">+</v-col>
                                        <v-col cols="auto">
                                            <span>도서산간 할증(<b>{{ order?.islandAmount.format() }}원</b>)</span>
                                        </v-col>
                                        <v-col cols="auto">-</v-col>
                                        <v-col cols="auto">
                                            <span>적립금 사용(<b>{{ order?.pointAmount.format() }}원</b>)</span>
                                        </v-col>
                                        <v-col cols="auto">-</v-col>
                                        <v-col cols="auto">
                                            <span>캐시 사용(<b>{{ order?.cashAmount.format() }}원</b>)</span>
                                        </v-col>
                                        <v-col cols="auto">=</v-col>
                                        <v-col cols="auto">
                                            <div class="d-flex align-center">
                                                <span>총 결제 금액</span><b class="font-size-20 font-size-md-24 ml-10px ml-md-12px">{{ totalAmount.format() }}원</b>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>

                            <table class="table--default">
                                <colgroup>
                                    <col style="width:20%">
                                    <col style="width:30%">
                                    <col style="width:20%">
                                    <col style="width:30%">
                                </colgroup>
                                <tr>
                                    <th>주문번호</th>
                                    <td>{{order.orderNo}}</td>
                                    <th>주문일</th>
                                    <td>{{order.createdAt.toDate()}}</td>
                                </tr>
                                <tr>
                                    <th>결제방법</th>
                                    <td>{{paymentWay}}</td>
                                    <th>주문상태</th>
                                    <td style="font-weight:bold">{{purchases[0]?.paymentStatus}}</td>
                                </tr>
                                <tr>
                                    <th>입금자명</th>
                                    <td colspan="3">{{order?.buyer?.name}}</td>
                                </tr>
                            </table>
                        </section>

                        <!-- <section class="page-section">
                            <div class="tit-wrap mb-10px mb-md-20px">
                                <h3 class="tit tit--xs">배송정보</h3>
                            </div>

                            <div>
                                <table class="table--default">
                                    <colgroup>
                                        <col style="width:20%">
                                        <col style="width:30%">
                                        <col style="width:20%">
                                        <col style="width:30%">
                                    </colgroup>
                                    <tr>
                                        <th>택배사</th>
                                        <td>{{purchase[0]?.shippingInfo?.courier}}</td>
                                        <th>운송장번호</th>
                                        <td>{{purchase[0]?.shippingInfo?.invoiceNumber}}</td>
                                    </tr>
                                    <tr>
                                        <th>택배유형</th>
                                        <td>{{purchase[0]?.shippingInfo?.method}}</td>
                                        <th>배송상태</th>
                                        <td>{{purchase[0]?.status}}</td>
                                    </tr>
                                </table>
                            </div>
                        </section> -->

                        <section class="page-section pb-0">
                            <div class="tit-wrap mb-10px mb-md-20px">
                                <h3 class="tit tit--xs">주문하신 분</h3>
                            </div>

                            <div>
                                <table class="table--default">
                                    <colgroup>
                                        <col style="width:20%">
                                        <col style="width:80%">
                                    </colgroup>
                                    <tr>
                                        <th>주문하신분</th>
                                        <td>{{order?.buyer?.name}}</td>
                                    </tr>
                                    <tr>
                                        <th>연락처</th>
                                        <td>{{order?.buyer?.phone}}</td>
                                    </tr>
                                    <tr>
                                        <th>이메일</th>
                                        <td>{{order?.buyer?.email}}</td>
                                    </tr>
                                    <tr>
                                        <th>주소</th>
                                        <td>{{`[${order?.shippingAddress?.postcode}] ${order?.shippingAddress?.address1} ${order?.shippingAddress?.address2}`}}</td>
                                    </tr>
                                    <tr>
                                        <th>받는사람 연락처</th>
                                        <td>{{order?.receiver?.phone}}</td>
                                    </tr>
                                </table>
                                <div class="d-print-none mt-20px mt-md-30px">
                                    <v-row class="row--x-small">
                                        <v-col cols="auto">
                                            <router-link to="/mypage/shop/purchases"><v-btn large outlined color="grey"><span class="grey--text text--darken-3">리스트</span></v-btn></router-link>
                                        </v-col>
                                        <v-spacer></v-spacer>
                                        <v-col cols="auto">
                                            <v-btn @click="print" large color="primary">프린트</v-btn>
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>

                <claim-dialog ref="claimDialog" @claim="search(false)" />
                <review-dialog ref="reviewDialog" @close="search(false)"/>
            </div>
        </div>
    </component>
</template>
<script>
import api from "@/api";
import ClaimDialog from "@/components/client/mypage/claim-dialog.vue";
import ReviewDialog from "@/components/client/mypage/review-dialog.vue";
import couriers from "@/assets/data/couriers.json";
export default {
    components: {
        ClaimDialog,
        ReviewDialog
    },
    data(){
        return {
            couriers,

            filter: {},

            page: 1,
            pageCount: 0,
            limit: 10,

            purchases: [],
            purchase: [],
            order: [],
            purchasesHeaders: [
                { text: "이미지", value: "product", align: "center", width: "12%" },
                { text: "구매상품정보", value: "name", align: "center", width: "13%" },
                { text: "제품가격", value: "saleAmount", align: "center", width: "12%" },
                { text: "적립금", value: "earnPointAmount", align: "center", width: "12%" },
                { text: "구매수량", value: "quantity", align: "center", width: "12%" },
                { text: "배송정보", value: "shippingInfo", align: "center", width: "12%", display: (code) => ["book"].includes(code) },
                { text: "-", value: "actions", align: "center", width: "12%" },
            ],
            code: "book"
        }
    },
    mounted(){
        if(this.logoff) this.$router.push(`/login`);
        this.init();
    },
    methods: {
        async init(){
            await this.search(false);
        },
        // async resend(purchase){
        //     await api.v1.me.shop.purchases.resend(purchase);
        //     alert("재발송되었습니다");
        // },
        async search(routable = false){
            let { order } = await api.v1.me.shop.orders.get({
                _id: this.$route.params._orders
            });
            // let { purchases } = await api.v1.me.shop.purchases.get({
            //     _orders: this.$route.params._orders
            // });

            this.order = order
            this.purchases = order.purchases;
            let purchase =  this.purchases.filter( item => item._id === this.$route.query._id )
            this.purchase = purchase
            if (this.purchases[0].ebookStatus) {
                this.code = "ebook"
            }
        },
        async claim(purchase, claimType){
            this.$refs.claimDialog.claimType = claimType;
            this.$refs.claimDialog.purchase = purchase;
            this.$refs.claimDialog.open();
        },
        review(purchase){
            this.$refs.reviewDialog.purchase = purchase;
            this.$refs.reviewDialog.open();
        },
        async confirmation(purchase){
            if(confirm('구매확정하시겠습니까?')){
                await api.v1.me.shop.purchases.put(purchase)
                alert('구매확정 되었습니다')
                await this.init()
            }
        },
        print(){
            let a
            function beforePrint(){
                a = document.body.innerHTML
                document.body.innerHTML = document.getElementById('print').innerHTML
                document.querySelector('.print-area').classList.add('v-application');
            }
            function afterPrint(){
                document.body.innerHTML = a
            }
            window.onbeforeprint = beforePrint
            window.onafterprint = afterPrint
            window.print()
        }
    },
    computed: {
        template(){ return () => import(`@/templates/${this.$theme.pages.mypage}`) },

        logoff(){
            return !this.$store.state.accessToken;
        },

        paymentWay(){
            let str = ""
            if(this.order.cashAmount && this.order.pointAmount && !this.order.paymentAmount) str =  '캐시 & 포인트 결제'
            if(this.order.cashAmount && !this.order.pointAmount && !this.order.paymentAmount) str =  '캐시 결제'
            if(!this.order.cashAmount && this.order.pointAmount && !this.order.paymentAmount) str =  '포인트 결제'
            if(!this.order.cashAmount && !this.order.pointAmount && this.order.paymentAmount) str =  '신용카드 결제'
            if(!this.order.cashAmount && this.order.pointAmount && this.order.paymentAmount) str =  '신용카드 & 포인트 결제'
            if(this.order.cashAmount && !this.order.pointAmount && this.order.paymentAmount) str =  '신용카드 & 캐시 결제'
            if(this.order.cashAmount && this.order.pointAmount && this.order.paymentAmount) str =  '신용카드 & 캐시 & 포인트 결제'
            return str
        },
        totalAmount(){
            return this.order?.saleAmount + this.order?.shippingAmount +this.order?.islandAmount - this.order?.pointAmount - this.order?.cashAmount
        }
    }
}
</script>

<style scoped>
@media print{
    .print-area__inner{
        padding:16px;
    }
    .print-area__inner .page-section{
        padding:10px 0!important;
    }
}
</style>